import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import CustomerList from "../ManageCustomers/components/customer-list";


const Customers = () => {

  const navigate = useNavigate();

  return (
    <div className="p-4">
      <div className="py-3 pl-4 pr-8 w-full flex justify-between shadow-md shadow-slate-400 rounded-lg">
        <button
          className="text-sm flex items-center justify-center p-2 border border-gray-600 hover:bg-gray-200 rounded-full shadow hover:shadow-lg ease-in-out duration-300 transition-all"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="size-4" />
        </button>
        <h1 className="text-center text-lg font-semibold capitalize w-full">
          Customers
        </h1>
      </div>
      <div className="shadow-md shadow-slate-300 mt-3">
        <CustomerList />
      </div>
    </div>
  );
}

export default Customers